export default function TimeZoneData({ container }) {
  return (
    <div className="mt-3">
      Local Time: {container.localeManager.moment().format("LLL")} - Server Time (UTC):{" "}
      {container.localeManager.moment().utc().format("LLL")}
    </div>
  );
}
